'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');

var FirmwareConfigView = AbstractFormView.extend({
    template: require('components/devices/templates/gateway/firmware_config'),

    events: function () {
        return _.extend({}, AbstractFormView.prototype.events, {
            'click button#js-success': 'validateForm',
            'click :checkbox': 'enableGroup',
            'change #read_interval-input': 'updateIntervalHint',
        });
    },

    errorMsgs: {
        max31: i18n.TR('Geben Sie bitte eine ganze Zahl zwischen 1 und 31 ein.'),
        max15: i18n.TR('Geben Sie bitte eine ganze Zahl zwischen 1 und 15 ein.'),
        mas720: i18n.TR('Geben Sie bitte eine ganze Zahl zwischen 1 und 720 ein.'),
        max65535: i18n.TR('Geben Sie bitte eine ganze Zahl zwischen 1 und 65535 ein.'),
        max255: i18n.TR('Geben Sie bitte eine ganze Zahl zwischen 0 und 255 ein.'),
    },

    initialize: function (options) {
        this.options = options;
        this.model = options.model;
        this.controller = options.controller;
        this.device = options.device;

        var type = this.device.get('type');

        this.canConfigureMBus = Consts.GatewayWithMBus.indexOf(type) != -1;
        this.isDirectlyConnected = type !== '5022';
        this.wmzIntervalRegister = type === '5578' ? 6488 : 6479;

        var formData =
            options.formData || (options.model ? options.model.toJSON() : undefined) || this.getFormDefaults() || {};
        AbstractFormView.prototype.initialize.apply(this, [
            {
                formData: formData,
                inputFields: this.getInputFields(),
            },
        ]);
    },

    getInputFields: function () {
        var inputFields = {};

        if (this.isDirectlyConnected) {
            inputFields['push_interval_0'] = {
                min: 1,
                max: 15,
                method: 'number',
                validIfNotVisible: true,
                error: {
                    id: 1,
                    message: this.errorMsgs.max15,
                },
            };
            inputFields['push_interval_1'] = {
                min: 1,
                max: 720,
                method: 'number',
                validIfNotVisible: true,
                error: {
                    id: 2,
                    message: this.errorMsgs.max720,
                },
            };
            inputFields['push_interval_2'] = {
                min: 1,
                max: 65535,
                method: 'number',
                validIfNotVisible: true,
                error: {
                    id: 3,
                    message: this.errorMsgs.max65535,
                },
            };
        }

        if (this.isDirectlyConnected) {
            inputFields['minimal_signal_quality'] = {
                min: 1,
                max: 31,
                method: 'number',
                validIfNotVisible: true,
                error: {
                    id: 0,
                    message: this.errorMsgs.max31,
                },
            };
        }

        if (this.canConfigureMBus) {
            inputFields['read_interval'] = {
                min: 1,
                max: 65535,
                method: 'number',
                error: {
                    id: 4,
                    message: this.errorMsgs.max65535,
                },
            };

            _.each(
                this.getPlugableWMZs(),
                function (wmz) {
                    inputFields[wmz.name] = {
                        min: 0,
                        max: 255,
                        method: 'number',
                        error: {
                            id: 4 + wmz.meterNr,
                            message: this.errorMsgs.max255,
                        },
                    };
                },
                this
            );
        }

        return inputFields;
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);

        data.type = this.device.get('type');
        data.error = this.error;

        data.values = {
            2: i18n.TR('EN1434'),
            3: i18n.TR('Multical3'),
            4: i18n.TR('Apator'),
            5: i18n.TR('SLS/WSF'),
        };
        data.mode_values = {
            0: i18n.TR('24h'),
            1: i18n.TR('Kont.'),
            2: i18n.TR('Coil'),
        };

        data.canConfigureMBus = this.canConfigureMBus;

        var wmzs = this.getPlugableWMZs();
        if (wmzs.length > 0) {
            var deviceLimit = wmzs.length;
            data.tabs = [];
            data.hasMultipleTabs = deviceLimit > 10;
            if (data.hasMultipleTabs) {
                for (var i = 0; i < Math.ceil(deviceLimit / 10); i++) {
                    var name = '' + (i * 10 + 1) + '-' + (i + 1) * 10;

                    // last tab?
                    if (Math.ceil(deviceLimit / 10) - (i + 1) === 0) {
                        name = '' + (i * 10 + 1) + '-' + deviceLimit;
                    }

                    data.tabs[i] = {
                        id: 'tab_' + i,
                        name: name,
                        wmzs: [],
                        active: i == 0,
                    };
                }
            } else {
                data.tabs[0] = { wmzs: [] };
            }

            var currentMeterCount = 0;
            _.each(wmzs, function (wmz) {
                data.tabs[Math.floor(currentMeterCount / 10)].wmzs.push({
                    adr: wmz.adr,
                    type: wmz.type,
                    mode: wmz.mode,
                    meterNr: wmz.meterNr,
                });
                currentMeterCount++;
            });
        }

        var registers = this.model.attributes;

        if (this.isDirectlyConnected) {
            data.min_csq = _.findWhere(registers, { address: 138 }).value;
            data.intervals = [
                _.findWhere(registers, { address: 700 }).value,
                _.findWhere(registers, { address: 701 }).value,
                _.findWhere(registers, { address: 702 }).value,
            ];
        }

        if (this.canConfigureMBus || data.type == '5022') {
            data.interval = _.findWhere(registers, { address: this.wmzIntervalRegister }).value;
            data.showIntervalHint = data.interval < 60;
        }

        return data;
    },

    getPlugableWMZs: function () {
        if (!this.canConfigureMBus) {
            return [];
        }

        var registers = this.model.attributes;
        var wmzs = [];

        if (this.device.get('type') == '5022') {
            var deviceLimit = _.findWhere(registers, { address: 6498 }).value;
            for (var i = 37000; i < 37000 + deviceLimit * 4; i += 4) {
                wmzs.push({
                    adr: _.findWhere(registers, { address: i }).value,
                    type: _.findWhere(registers, { address: i + 1 }).value,
                    mode: _.findWhere(registers, { address: i + 2 }).value,
                    meterNr: (i - 37000) / 4,
                    name: 'AddressWMZ' + (i - 37000) / 4,
                });
            }
        } else {
            wmzs = [
                {
                    adr: _.findWhere(registers, { address: 6470 }).value,
                    type: _.findWhere(registers, { address: 6471 }).value,
                    mode: _.findWhere(registers, { address: 6472 }).value,
                    meterNr: 0,
                    name: 'AddressWMZ0',
                },
                {
                    adr: _.findWhere(registers, { address: 6473 }).value,
                    type: _.findWhere(registers, { address: 6474 }).value,
                    mode: _.findWhere(registers, { address: 6475 }).value,
                    meterNr: 1,
                    name: 'AddressWMZ1',
                },
                {
                    adr: _.findWhere(registers, { address: 6476 }).value,
                    type: _.findWhere(registers, { address: 6477 }).value,
                    mode: _.findWhere(registers, { address: 6478 }).value,
                    meterNr: 2,
                    name: 'AddressWMZ2',
                },
            ];
        }

        return wmzs;
    },

    getRegisterList: function (form) {
        var registerList = [{ address: 1, value: parseInt(this.device.get('type')) }];
        switch (this.device.get('type')) {
            case '5022':
                registerList.push({ address: this.wmzIntervalRegister, value: form.interval / 1 });
                var meterCount = 0;
                for (var i = 0; i < 240; i += 4) {
                    meterCount = i / 4;
                    registerList.push(
                        {
                            address: 37000 + i,
                            value: form['active' + meterCount] ? form['adr_' + meterCount] / 1 : 255,
                        },
                        { address: 37000 + i + 1, value: form['type_' + meterCount] / 1 },
                        { address: 37000 + i + 2, value: form['mode_' + meterCount] / 1 }
                    );
                }
                break;

            case '5018':
                registerList.push(
                    { address: 138, value: 8 },
                    { address: 700, value: form.push_0 / 1 },
                    { address: 701, value: form.push_1 / 1 },
                    { address: 702, value: form.push_2 / 1 }
                );
                break;

            default:
                registerList.push(
                    { address: 1, value: parseInt(this.device.get('type')) },
                    { address: 138, value: 8 }, // form.min_csq/1},
                    { address: 700, value: form.push_0 / 1 },
                    { address: 701, value: form.push_1 / 1 },
                    { address: 702, value: form.push_2 / 1 },
                    { address: 6470, value: form.active0 ? form.adr_0 / 1 : 255 },
                    { address: 6471, value: form.type_0 / 1 },
                    { address: 6472, value: form.mode_0 / 1 },
                    { address: 6473, value: form.active1 ? form.adr_1 / 1 : 255 },
                    { address: 6474, value: form.type_1 / 1 },
                    { address: 6475, value: form.mode_1 / 1 },
                    { address: 6476, value: form.active2 ? form.adr_2 / 1 : 255 },
                    { address: 6477, value: form.type_2 / 1 },
                    { address: 6478, value: form.mode_2 / 1 },

                    { address: this.wmzIntervalRegister, value: form.interval / 1 }
                );
        }
        return registerList;
    },

    validateWMZAddresses: function () {
        var form = Backbone.Syphon.serialize(this);
        var addrList = [];
        _.each(this.getPlugableWMZs(), function (wmz) {
            var obj = {};
            obj[wmz.meterNr] = form['adr_' + wmz.meterNr];
            addrList.push({ nr: wmz.meterNr, addr: form['adr_' + wmz.meterNr] });
        });
        var duplicates = [];
        for (var addr = 0; addr < addrList.length; addr++) {
            // exclude inactive meteres from the duplicate search
            if (!form['active' + addr]) {
                continue;
            }
            var currentValue = addrList[addr].addr;
            if (currentValue != 255) {
                for (var compareAddr = addr + 1; compareAddr < addrList.length; compareAddr++) {
                    if (currentValue === addrList[compareAddr].addr) {
                        // duplicated value found
                        duplicates.push(addrList[addr].nr);
                        duplicates.push(addrList[compareAddr].nr);
                    }
                }
            }
        }
        return _.unique(duplicates);
    },

    validateForm: function (e) {
        e.preventDefault();
        var self = this;

        if (this.allFieldsValid()) {
            var duplicates = this.validateWMZAddresses();
            if (duplicates.length > 0) {
                // flash duplicates and their tab and abort
                _.each(duplicates, function (element) {
                    Decorator.flash($('#AddressWMZ' + element + '-input'));
                    Decorator.flash($('[href=#tab_' + Math.floor(element / 10) + ']'));
                });
                return;
            }
            var form = Backbone.Syphon.serialize(this);

            Decorator.disableElement('.modal-dialog');

            // HACK: 5022 uses the GenericModbus-BaseDeviceController -> fake 'writeFirmwareConfig'-method
            if (!this.controller.writeFirmwareConfig) {
                this.controller.writeFirmwareConfig = function (options) {
                    var cfgUpdateReq = App.request('gateway:firmwareconfig:write', options.device, options.config);
                    $.when(cfgUpdateReq).done(function (result) {
                        if (result === undefined) {
                            options.error_cb();
                        } else {
                            options.success_cb(result);
                        }
                    });
                };
            }

            this.controller.writeFirmwareConfig({
                device: this.device,
                config: this.getRegisterList(form),

                success_cb: function () {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen gespeichert.'));
                },

                error_cb: function (errors) {
                    self.error = i18n.TR('Einstellungen konnten nicht geschrieben werden.');
                    self.formData = form;
                    App.refreshModal(self);
                },
            });
        }
    },

    enableGroup: function (e) {
        var id = e.currentTarget.id.substring(8);
        $("[id*='WMZ" + id + "']").prop('disabled', !e.currentTarget.checked);
    },

    updateIntervalHint: function (e) {
        var form = Backbone.Syphon.serialize(this);
        Misc.setVisible('#js-interval-hint', form.interval / 1 < 60);
    },
});

FirmwareConfigView.show = function (options) {
    // request configuration data
    var req = App.request('gateway:firmwareconfig:read', options.device);
    $.when(req).done(function (resp) {
        if (!resp || resp.toJSON().length == 0) {
            Notification.show(
                'error',
                i18n.TR('Fehler'),
                i18n.TR('Firmware Konfiguration konnte nicht geladen werden.')
            );
            return;
        }

        var c = new FirmwareConfigView({
            model: resp,
            controller: options.controller,
            device: options.device,
        });
        App.showModal(c);
    });
};

module.exports = FirmwareConfigView;
